import styled from 'styled-components';
import { Button, Tooltip } from 'antd';

export const TableContainer = styled.div`
  background: #ffffff;
  overflow: auto;
  width: 100%;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const TopScrollbar = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 11;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  background: #fff;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 2px solid #f5f5f5;
  table-layout: auto;
`;

export const StyledTableHead = styled.thead`
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const StyledTableHeaderRow = styled.tr``;

export const StyledTableHeader = styled.th`
  color: ${props => props.theme?.['@table-head-color'] || 'rgba(0, 0, 0, 0.85)'};
  font-weight: 600;
  font-size: 15px;
  text-align: left;
  padding: 16px;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
  user-select: none;
  background: #ffffff;
  white-space: nowrap;

  ${props =>
    props.sortable &&
    `
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.02);
    }
  `}

  ${props =>
    props.sorted &&
    `
    color: #47a4ea;
  `}

  @media (max-width: 1500px) {
    font-size: 13px;
    padding: 12px;
  }
`;

export const StyledTableBody = styled.tbody``;

export const StyledTableRow = styled.tr`
  ${props =>
    props.selected &&
    `
    background: rgba(71, 164, 234, 0.1);
  `}

  ${props =>
    props.expandable &&
    `
    &:hover {
      background: rgba(71, 164, 234, 0.06) !important;
      border-left: 3px solid #47a4ea;
    }
  `}

  &:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.02);
  }
`;

export const StyledTableCell = styled.td`
  padding: 16px;
  background: #ffffff;
  border-bottom: 1px solid #f0f2f5;
  font-weight: 500;
  color: ${props => props.theme?.['@table-text-color'] || 'rgba(0, 0, 0, 0.85)'}cf;
  font-size: 14px;
  overflow-wrap: break-word;

  @media (max-width: 1500px) {
    font-size: 13px;
    padding: 12px;
  }
`;

export const SortIndicator = styled.span`
  display: inline-flex;
  flex-direction: column;
  font-size: 10px;
  vertical-align: middle;
  flex-shrink: 0;

  .sort-arrow-up {
    margin-bottom: -2px;
    color: ${props =>
      props.direction === 'asc' ? '#47a4ea' : 'rgba(0, 0, 0, 0.25)'};
  }

  .sort-arrow-down {
    color: ${props =>
      props.direction === 'desc' ? '#47a4ea' : 'rgba(0, 0, 0, 0.25)'};
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-top: 1px solid #f0f2f5;
  background: #ffffff;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const PaginationInfo = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
`;

export const PaginationControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  & > span {
    margin: 0 8px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
  }
`;

export const PaginationButton = styled(Button)`
  &.ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const EmptyState = styled.div`
  padding: 60px 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
`;

export const ResizeHandle = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 10px;
  cursor: col-resize;
  user-select: none;
  touch-action: none;
  z-index: 1;

  &:hover {
    background: rgba(71, 164, 234, 0.3);
  }

  ${props =>
    props.isResizing &&
    `
    background: rgba(71, 164, 234, 0.5);
  `}
`;

export const DraggableHeader = styled.th`
  color: ${props => props.theme?.['@table-head-color'] || 'rgba(0, 0, 0, 0.85)'};
  font-weight: 600;
  font-size: 15px;
  text-align: left;
  padding: 16px;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
  user-select: none;
  background: #ffffff;
  white-space: nowrap;

  ${props =>
    props.sortable &&
    `
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.02);
    }
  `}

  ${props =>
    props.sorted &&
    `
    color: #47a4ea;
  `}

  ${props =>
    props.isDragging &&
    `
    opacity: 0.5;
  `}

  ${props =>
    props.isOver &&
    `
    border-left: 2px solid #47a4ea;
  `}

  ${props =>
    props.draggable &&
    `
    cursor: grab;
  `}

  @media (max-width: 1500px) {
    font-size: 13px;
    padding: 12px;
  }
`;

export const ExportButton = styled(Button)`
  margin-left: 10px;
  border-radius: 5px;
  height: 34px;
  &.ant-btn {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;